// Copyright (c) 2026 Solartek LLC. All rights reserved.

import { registerNamespace } from '@/lib/i18n-namespace';
import en from '@/locales/en/meetings.json';
import ar from '@/locales/ar/meetings.json';

/** Namespace of meetings (workforce controls §7): the meetings pages, the portal, the settings section, the menu entries. */
export const MEETINGS_NS = 'meetings';
registerNamespace(MEETINGS_NS, en, ar);
